import styled from "styled-components"
import UsersTable from "./usersTable.jsx"



let Container=styled.div`
	color:white
`;




export default function UsersReport(props){
	let {usuarios,setOpen}=props
	return(
		<Container>
			<UsersTable users={usuarios} />
		</Container>



		)

}